var _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenEva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 240,
    viewBox: "0 0 158.75 63.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -233.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-162.52 -5.91)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 114.41 159.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#5d6ad8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2568 0 0 1.2568 85.939 171.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 4c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5zm0 14c-2.03 0-4.43-0.82-6.14-2.88 1.69-1.32 3.82-2.12 6.14-2.12s4.45 0.8 6.14 2.12c-1.71 2.06-4.11 2.88-6.14 2.88z",
    fill: "#dd5858"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90311 0 0 .90311 66.285 175.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 4-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 163.14,
    y: 166.02,
    width: 49.138,
    height: 18.391,
    ry: 9.1957,
    fill: "#868fe2",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m160.44 189.55c7.6296-7.4485 6.011-11.685 6.011-11.685l8.7412 6.2863s-4.9075 2.865-14.752 5.3986z",
    fill: "#868fe2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 170.34 172.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 177.44 172.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 184.53 172.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 191.63 172.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#e6e8f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 198.72 172.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#e6e8f8"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenEva);
export default __webpack_public_path__ + "static/media/gen-eva.3f76f87eb7f67eaf69258c768729b483.svg";
export { ForwardRef as ReactComponent };